import React from 'react';

import {translate} from 'iss/strings';
import {addQuestionGroupToQuestion} from 'iss/service/QuestionService';
import {runBatchOps} from 'iss/utils/batchOps';
import {CollapsibleButtonPanel} from 'iss/widgets/Panels';
import {QuestionList} from 'iss/widgets/QuestionList';
import {QuestionGroupSelector} from 'iss/widgets/Selectors';
import {ModalForm} from 'iss/widgets/batchOps/ModalForm';
import {listFailuresWithMessage} from 'iss/widgets/batchOps/question/BatchOpFailure';
import validators from 'iss/widgets/form/validation/validators';

const addQuestionGroup = {
    id: "addGroup",
    title: "questionOperations.addGroup.title",
    progressMessage: "questionOperations.addGroup.progressMessage",
    components: {
      settings: ({operationTargets, onCancel, startOperation}) =>
      <ModalForm proceedText={translate('questionOperations.addGroup.proceed')}
        onSubmit={(formData) => startOperation(addQuestionGroups(operationTargets, formData))}
        onCancel={onCancel}>
        <QuestionGroupSelector id="groups" valuePath="groupId" label="questionOperations.addGroup.chooseQuestionGroup" clearable={false} validate={validators.required} />
        <p>
          {translate('questionOperations.addGroup.confirmMessage', {count: operationTargets.length})}
        </p>
        <CollapsibleButtonPanel buttonText={translate('questionOperations.addGroup.questions')}>
          <QuestionList compact={true} questions={operationTargets} />
        </CollapsibleButtonPanel>
      </ModalForm>,
      success: <p>{translate("questionOperations.addGroup.success")}</p>,
      failure: listFailuresWithMessage("questionOperations.addGroup.failure")
    },
};

function addQuestionGroups(targets, {groupId}) {
  const ops = targets.map((target) => (
    {operation: addQuestionGroupToQuestion(target.id, groupId),
    question: target
    }));
  return runBatchOps(ops);
}

export default addQuestionGroup;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/question/addQuestionGroup.jsx